import { createRouter, createWebHashHistory } from "vue-router"

import HomeRoutes from "./home/HomeRoutes.js"
import OvertimeRoutes from "./overtime_tracker/OvertimeRoutes.js"
import VariousRoutes from "./various/VariousRoutes.js"
import GroceriesRoutes from "./groceries/GroceriesRoutes.js"
import FinancesRoutes from "./finances/FinancesRoutes.js"
import CalendarRoutes from "./calendar/CalendarRoutes.js"

export default createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  routes: [
    ...HomeRoutes,
    ...OvertimeRoutes,
    ...VariousRoutes,
    ...GroceriesRoutes,
    ...FinancesRoutes,
    ...CalendarRoutes,
  ],
})
